import { render } from "./ProjectsPage.vue?vue&type=template&id=a6765130&scoped=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&lang=js"

import "./ProjectsPage.vue?vue&type=style&index=0&id=a6765130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6765130"]])

export default __exports__